import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function VkVideoStatus({ data, className }) {
    const { t } = useTranslation();
    const [status, setStatus] = useState("");
    const [statusVariant, setStatusVariant] = useState("warning");

    useEffect(() => {
        if (data?.status && data?.status !== 1) {
            setStatusVariant([3, 4, 5].includes(data.status) ? "warning" : "danger");
            switch (data.status) {
                case 3:
                    return setStatus(t("Видео загружается"));
                case 4:
                    return setStatus(t("Видео создается"));
                case 5:
                    return setStatus(t("Видео обрабатывается"));
                case 11:
                    return setStatus(t("Видео заблокировано"));
                case 12:
                    return setStatus(t("Видео содержит запрещенный контент"));
                case 13:
                    return setStatus(t("Видео нарушает авторские права"));
                default:
                    return setStatus(`${t("Ошибка видео")} (code: ${data.status})`);
            }
        }
    }, [data]);

    return status ? (
        <Badge variant={statusVariant} className={className}>
            {status}
        </Badge>
    ) : (
        <></>
    );
}

export default VkVideoStatus;
